import component from "./App.component";

import "res-components/build/assets/index.css";
import "res-components/build/assets/MainNav.css";

export default component;
